import dayjs from 'dayjs';
import { calculateDateRange } from '../../utils';

export const ADVANCED_DATE_RANGE_PRESETS = [
  'Current week',
  'Last week',
  'Current month',
  'Last month',
  'Last 30 days',
] as const;

export type AdvancedDateRangePreset = (typeof ADVANCED_DATE_RANGE_PRESETS)[number];
export type DateRangeValue = { startDate: Date; endDate: Date };

export const orderDateRange = (first: Date, second: Date): DateRangeValue =>
  dayjs(first).isAfter(second, 'day')
    ? { startDate: second, endDate: first }
    : { startDate: first, endDate: second };

export const getMatchingAdvancedPreset = (
  startDate: Date,
  endDate: Date
): AdvancedDateRangePreset | null =>
  ADVANCED_DATE_RANGE_PRESETS.find((preset) => {
    const range = calculateDateRange(preset);
    return (
      dayjs(startDate).isSame(range.startDate, 'day') && dayjs(endDate).isSame(range.endDate, 'day')
    );
  }) ?? null;
